<template>
    <div class="content-wrapper">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
        <div class="content">
            <AddChannelMarkers stage2></AddChannelMarkers>
            <div class="mt-12 d-flex justify-center" v-if="isLoading">
                <v-progress-circular indeterminate color="mainNew"></v-progress-circular>
            </div>
            <div v-else>
                <h2 class="dashboard mt-12">
                    Создание канала...
                </h2>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import AddChannelMarkers from '@/components/addConnector/AddChannelMarkers.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'
import { PROVIDER_TYPES, PROVIDER_TO_CHANNEL_MAP, CONNECTOR_TYPES } from '@/vars/general'
import { createChannel } from '@/api/networkFixer'
import { fetchConnector } from '@/api/projects'

export default {
    name: 'AddChannelStage2',
    components: {
        AddChannelMarkers,
        Breadcrumbs,
    },
    data: () => ({
        isLoading: true,
    }),
    computed: {
        ...mapState('project', ['currentAddingConnector']),
        project() {
            return this.$store.getters.projectById(this.$router.currentRoute.params.id)
        },
        breadcrumbs() {
            if (!this.project) {
                return []
            }
            return [
                {
                    text: this.project.name,
                    to: `/project/${this.project.id}`,
                },
                {
                    text: 'ДОБАВИТЬ КАНАЛ',
                    disabled: true,
                    to: '',
                },
            ]
        },
    },
    methods: {
        async createAndAddChannel() {
            if (!this.project) {
                this.$store.dispatch('callNotify', 'Ошибка: проект не найден')
                return
            }

            const projectId = this.project.id

            // currentAddingConnector приходит из Stage1 и содержит providerType
            const providerType = this.currentAddingConnector?.providerType || this.currentAddingConnector?.id
            const isWhatsappMailing = this.currentAddingConnector?.isWhatsappMailing || false

            if (!providerType) {
                this.$store.dispatch('callNotify', 'Ошибка: не указан тип провайдера')
                this.$router.push(`/project/${projectId}`)
                return
            }

            let connectorType
            // Если это WhatsApp (рассылки), создаем как источник (коннектор)
            if (isWhatsappMailing && providerType === PROVIDER_TYPES.whatsapp) {
                connectorType = CONNECTOR_TYPES.whatsapp
            } else {
                // Для остальных - создаем как канал
                const channelType = this.currentAddingConnector?.channelType || PROVIDER_TO_CHANNEL_MAP[providerType]
                if (!channelType) {
                    this.$store.dispatch('callNotify', 'Ошибка: не указан тип канала')
                    this.$router.push(`/project/${projectId}`)
                    return
                }
                connectorType = channelType
            }

            // Создаём объект коннектора
            // Для WhatsApp (рассылки) не передаем providerType, так как это коннектор, а не канал
            const connectorData = {
                projectId,
                connectorType: connectorType,
                domain: null,
                settings: {},
            }
            // providerType передаем только для каналов
            if (!isWhatsappMailing) {
                connectorData.providerType = providerType
            }
            const connector = await this.$store.dispatch('project/createConnector', connectorData)

            // Отправляем на бэк и сохраняем в store
            const res = await this.$store.dispatch('project/addConnector', connector)
            if (res.error) {
                this.$store.dispatch('callNotify', 'Ошибка при создании коннектора')
                this.$router.push(`/project/${projectId}`)
                return
            }

            // Получаем обновленный коннектор после создания
            const connectorId = connector.connectorId
            let updatedConnector = connector
            
            if (connectorId) {
                try {
                    const { data: fetchedConnector, error } = await fetchConnector(connectorId)
                    if (!error && fetchedConnector) {
                        updatedConnector = fetchedConnector
                        this.$store.commit('updateConnector', fetchedConnector)
                    }
                } catch (e) {
                    console.error('Ошибка при получении данных коннектора:', e)
                }
            }

            // Сохраняем коннектор в loggedAddingConnector для Stage3
            this.$store.commit('project/setLoggedAddingConnector', updatedConnector)

            // После успешного создания коннектора вызываем createChannel только для каналов
            if (connectorId && !isWhatsappMailing) {
                const channelRes = await createChannel({ connectorId })
                if (channelRes.error) {
                    console.error('Ошибка при создании канала через networkFixer:', channelRes.error)
                    // Не прерываем процесс, так как коннектор уже создан
                }
            }

            // После создания коннектора переходим на Stage3
            this.$router.push(`/project/${projectId}/addChannelStage3`)
        },
    },
    async created() {
        try {
            await this.createAndAddChannel()
        } catch (error) {
            console.error('Ошибка при создании канала:', error)
            const errorMessage = 'Ошибка при создании канала'
            this.$store.dispatch('callNotify', errorMessage)
            if (this.project) {
                this.$router.push(`/project/${this.project.id}`)
            }
        } finally {
            this.isLoading = false
        }
    },
}
</script>

<style lang="sass" scoped></style>


